export default {"src":"/_next/static/media/rightArrowDarkIcon.2d68e8bd.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};